import React from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
import save from "assets/icon/save.svg";
import Cancel from "assets/icon/CancelIcon-manufacture.svg";

import Loader from 'components/Loader';

const ConfirmationDialouge = (props) => {
  const { isOpen, message, loading, onToggle, onContinue, onCancel, show, data , endMessage } = props;

  return (
    <Modal centered isOpen={isOpen} toggle={onToggle}>
      <ModalBody className='m-2 p-4'>
        {loading && <Loader />}
        <h6 className='f-24 '>Confirmation!</h6>
        <p className='f-15 font-weight-400'>{message} {data && data.poid} ?</p>
        {show ?<p className='f-15 font-weight-400'>{endMessage}</p> : {} }
        <div className='text-end pt-4'>
          <Button color='cancel' className='reset' outline onClick={onCancel}>
             <span className="right_5">
                          <img src={Cancel} alt="" />
                        </span>{" "}
            Cancel
          </Button>
          {show ?
            <Button className='search' color='primary' onClick={onContinue}>
                <span className="right_5">
                            <img src={save} alt="" />
                          </span>{" "}
              Ok
            </Button> :
            <Button className='search' color='primary' onClick={onContinue}>
                <span className="right_5">
                            <img src={save} alt="" />
                          </span>{" "}
              Yes
            </Button>
          }
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmationDialouge;
